import {registry as OddRootsRegistry} from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat5_dzialania_na_pierwiastkach_types/OddRootValueTask";
import {registry as FactorSumRegistry} from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat1_potegi_naturalne_types/PowFactorSumTask";
import {registry as InverseInterestRegistry} from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat3_procent_types/InverseCompoundInterestTasks";
import { registry as BasicRootOperationsRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat5_dzialania_na_pierwiastkach_types/BasicRootOperationsTasks";
import { registry as FractionRootProductsRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat5_dzialania_na_pierwiastkach_types/FractionRootProductTask";
import { registry as OrderOfOperationsRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat1_dzialania_types";
import { registry as RomanNumeralsRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat12_systemy_liczbowe/podtemat1_cyfry_rzymskie";

// Dział 1 → Temat 1 → Podtemat 1: Działania (pierwiastki)
import * as RootSumSquareClosedTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat1_dzialania_types/RootSumSquareClosedTask";
import * as RootSumCubeClosedTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat1_dzialania_types/RootSumCubeClosedTask";
import * as RootBinomialOpenTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat1_dzialania_types/RootBinomialOpenTask";
import * as RationalizeSimpleDenominatorOpenTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat1_dzialania_types/RationalizeSimpleDenominatorOpenTask";
import * as RationalizeConjugateDenominatorOpenTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat1_dzialania_types/RationalizeConjugateDenominatorOpenTask";
import * as BasicIntegerOperationsOpenTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat1_dzialania_types/BasicIntegerOperationsOpenTask";
import * as FractionCommonDenominatorOpenTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat1_dzialania_types/FractionCommonDenominatorOpenTask";
import * as FractionMixedCommonDenominatorOpenTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat1_dzialania_types/FractionMixedCommonDenominatorOpenTask";
import * as FractionMultiplyBracketPlusMinusOpenTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat1_dzialania_types/FractionMultiplyBracketPlusMinusOpenTask";


// Dział 1 → Temat 1 → Podtemat 2: Wartość bezwzględna
import * as AbsSqrtMinusIntValueTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat2_wartosc_bezwzgledna_types/AbsSqrtMinusIntValueTask";
import * as AbsIntValueTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat2_wartosc_bezwzgledna_types/AbsIntValueTask";
import * as AbsSqrtAbsPairOpenTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat2_wartosc_bezwzgledna_types/AbsSqrtAbsPairOpenTask";


// Dział 1 → Temat 1 → Podtemat 3: Zbiory (włączenia–wyłączenia, nowoczesne fabuły)
import * as InclusionExclusionModernTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat3_zbiory_types/InclusionExclusionModernTask";
import * as InclusionExclusionUnionTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat3_zbiory_types/InclusionExclusionUnionTask";
import * as ListDefinedSetElementsTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat3_zbiory_types/ListDefinedSetElementsTask";
import * as SetOpsFourResultsTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat3_zbiory_types/SetOpsFourResultsTask";
import * as VennSetPaintTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat3_zbiory_types/VennSetPaintTask";

// Dział 1 → Temat 1 → Podtemat 4: Przedziały
import * as InequalityToInfinityTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat4_przedzialy_types/InequalityToInfinityTask";
import * as InequalityBetweenTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat4_przedzialy_types/InequalityBetweenTask";
import * as InequalityUnionOneSidedTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat4_przedzialy_types/InequalityUnionOneSidedTask";
import * as GraphIntervalToSetTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat4_przedzialy_types/GraphIntervalToSetTask";
import * as IntervalsOpsABTask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat4_przedzialy_types/IntervalsOpsABTask";
import * as RealsMinusATask from "../../generators/dzial1_liczby_i_dzialania/temat1_dzialania/podtemat4_przedzialy_types/RealsMinusATask";



// Dział 1 → Temat 2 → Podtemat 1: Potęgi o wykładniku naturalnym
import * as PowSumExponentsTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat1_potegi_naturalne_types/PowSumExponentsTask";
import * as PowDiffExponentsTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat1_potegi_naturalne_types/PowDiffExponentsTask";
import * as PowPowerOfPowerTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat1_potegi_naturalne_types/PowPowerOfPowerTask";
import * as PowMixMulDivTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat1_potegi_naturalne_types/PowMixMulDivTask";
import * as PowMixParensTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat1_potegi_naturalne_types/PowMixParensTask";
import * as PowMixedFamilyToSinglePowerTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat1_potegi_naturalne_types/PowMixedFamilyToSinglePowerTask";

// Dział 1 → Temat 2 → Podtemat 2: Potęgi o wykładniku całkowitym
import * as NegativeExponentBasicTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat2_potegi_calkowite_types/NegativeExponentBasicTask";
import * as PresentAsPowerWithGivenBaseTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat2_potegi_calkowite_types/PresentAsPowerWithGivenBaseTask";
import * as MixedFamilyIntegerToSinglePowerTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat2_potegi_calkowite_types/MixedFamilyIntegerToSinglePowerTask";

// Dział 1 → Temat 2 → Podtemat 3
import * as RadicalToRationalPowerTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat3_potegi_wymierne_types/RadicalToRationalPowerTask";
import * as RationalPowerToRadicalTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat3_potegi_wymierne_types/RationalPowerToRadicalTask";
import * as MixedFamilyRationalToSinglePowerTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat3_potegi_wymierne_types/MixedFamilyRationalToSinglePowerTask";
import * as RadicalFractionToRationalPowerTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat3_potegi_wymierne_types/RadicalFractionToRationalPowerTask";
import * as MixedFamilyRationalFractionToSinglePowerTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat3_potegi_wymierne_types/MixedFamilyRationalFractionToSinglePowerTask";
import * as MixedFamilyRationalFractionBarToSinglePowerTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat3_potegi_wymierne_types/MixedFamilyRationalFractionBarToSinglePowerTask";



// Dział 1 → Temat 2 → Podtemat 4: Notacja wykładnicza
import * as ScientificFromNotationTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat4_notacja_wykladnicza_types/ScientificFromNotationTask";
import * as ScientificToNotationTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat4_notacja_wykladnicza_types/ScientificToNotationTask";
import * as ScientificMultiplyTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat4_notacja_wykladnicza_types/ScientificMultiplyTask";
import * as ScientificDivideTask from "../../generators/dzial1_liczby_i_dzialania/temat2_potegi/podtemat4_notacja_wykladnicza_types/ScientificDivideTask";


import * as LogSimpleTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat1_definicja_types/LogSimpleTask";
import * as LogDomainTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat1_definicja_types/LogDomainTask";
import * as LogCommonTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat1_definicja_types/LogCommonTask";


import * as LogPropSumTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat2_wlasnosci_types/LogPropSumTask";
import * as LogPropDiffTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat2_wlasnosci_types/LogPropDiffTask";
import * as LogPropCoefTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat2_wlasnosci_types/LogPropCoefTask";
import * as LogPropSum3Task from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat2_wlasnosci_types/LogPropSum3Task";
import * as LogPropMixTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat2_wlasnosci_types/LogPropMixTask";
import * as LogPropCoefMixTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat2_wlasnosci_types/LogPropCoefMixTask";
import * as LogPropPowerLogTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat2_wlasnosci_types/LogPropPowerLogTask";
import * as LogNumberAsLogTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat2_wlasnosci_types/LogNumberAsLogTask";


import * as LogComputePowerTask from "../../generators/dzial1_liczby_i_dzialania/temat3_logarytmy/podtemat3_obliczanie_types/LogComputePowerTask";


// Dział 1 → Temat 4 → Podtemat 1: Obliczanie procentów
import * as PercentOfNumberTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat1_procenty_obliczanie_types/PercentOfNumberTask";
import * as PercentFindWholeTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat1_procenty_obliczanie_types/PercentFindWholeTask";
import * as PercentWhatPartTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat1_procenty_obliczanie_types/PercentWhatPartTask";

// Dział 1 → Temat 4 → Podtemat 2: Zmiany procentowe
import * as PercentChangeSingleTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat2_zmiany_procentowe_types/PercentChangeSingleTask";
import * as PercentChangeDoubleTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat2_zmiany_procentowe_types/PercentChangeDoubleTask";
import * as PercentChangeReverseSingleTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat2_zmiany_procentowe_types/PercentChangeReverseSingleTask";
import * as PercentChangeReverseDoubleTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat2_zmiany_procentowe_types/PercentChangeReverseDoubleTask";
// Dział 1 → Temat 4 → Podtemat 3: Porównania procentowe
import * as PercentComparisonRelativeTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat3_porownania_procentowe_types/PercentComparisonRelativeTask";
import * as PercentPointsDifferenceTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat3_porownania_procentowe_types/PercentPointsDifferenceTask";
import * as PercentPartyRelativeTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat3_porownania_procentowe_types/PercentPartyRelativeTask";
import * as PercentPartyPointsTask from "../../generators/dzial1_liczby_i_dzialania/temat4_procenty/podtemat3_porownania_procentowe_types/PercentPartyPointsTask";


// Dział 1 → Temat 1 → Podtemat 1: Podzielność liczb całkowitych
import * as DivisibilityYesNoTask from "../../generators/dzial1_liczby_i_dzialania/temat5_teoria_liczb/podtemat1_podzielnosc_liczb_calkowitych_types/DivisibilityBasicTask";
import * as DivisibilityFillDigitTask from "../../generators/dzial1_liczby_i_dzialania/temat5_teoria_liczb/podtemat1_podzielnosc_liczb_calkowitych_types/DivisibilityFillDigitTask";

import * as PrimeFactorizationBasicTask from "../../generators/dzial1_liczby_i_dzialania/temat5_teoria_liczb/podtemat2_liczby_pierwsze_types/PrimeFactorizationBasicTask";

import * as NwdNwwUnifiedTask from "../../generators/dzial1_liczby_i_dzialania/temat5_teoria_liczb/podtemat3_nwd_nww_types/NwdNwwUnifiedTask";

import { registry as NaturalAddSubtractRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat7_liczby_naturalne/podtemat1_dodawanie_odejmowanie";
import { registry as NaturalMultiplicationRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat7_liczby_naturalne/podtemat2_mnozenie";
import { registry as NaturalDivisionRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat7_liczby_naturalne/podtemat3_dzielenie";

import { registry as NaturalWrittenAdditionRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat8_dzialania_pisemne/podtemat1_dodawanie_pisemne";
import { registry as NaturalWrittenSubtractionRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat8_dzialania_pisemne/podtemat2_odejmowanie_pisemne";
import { registry as NaturalWrittenMultiplicationRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat8_dzialania_pisemne/podtemat3_mnozenie_pisemne";
import { registry as NaturalWrittenDivisionRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat8_dzialania_pisemne/podtemat4_dzielenie_pisemne";
import { registry as IntegerNumberLineRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat9_liczby_calkowite/podtemat1_os_liczbowa";
import { registry as IntegerAddSubtractRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat9_liczby_calkowite/podtemat2_dodawanie_odejmowanie";
import { registry as IntegerMultiplicationRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat9_liczby_calkowite/podtemat3_mnozenie";
import { registry as IntegerDivisionRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat9_liczby_calkowite/podtemat4_dzielenie";
import { registry as FractionSimplifyingRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat10_ulamki_zwykle/podtemat1_skracanie_rozszerzanie";
import { registry as FractionComparingRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat10_ulamki_zwykle/podtemat2_porownywanie";
import { registry as FractionAddSubtractRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat10_ulamki_zwykle/podtemat3_dodawanie_odejmowanie";
import { registry as FractionMultiplicationRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat10_ulamki_zwykle/podtemat4_mnozenie";
import { registry as FractionDivisionRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat10_ulamki_zwykle/podtemat5_dzielenie";
import { registry as MixedNumbersRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat10_ulamki_zwykle/podtemat6_liczby_mieszane";
import { registry as FractionCombinedRationalRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat10_ulamki_zwykle/podtemat7_dzialania_laczne_wymierne";





//generators/dzial2_algebra/temat1_wyrazenia/podtemat1_upraszczanie_wyrazen_types
import * as SimplifyParenthesesTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat1_upraszczanie_wyrazen_types/SimplifyParenthesesTask";
import * as MultiplyBinomialsTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat1_upraszczanie_wyrazen_types/MultiplyBinomialsTask";
import * as MultiplyBinomialByTrinomialTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat1_upraszczanie_wyrazen_types/MultiplyBinomialByTrinomialTask";
import * as AddOrSubtractBinomialTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat1_upraszczanie_wyrazen_types/AddOrSubtractBinomialTask";
import * as AddOrSubtractTrinomialTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat1_upraszczanie_wyrazen_types/AddOrSubtractTrinomialTask";
//generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types
import * as SquareOfSumLiteralTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/SquareOfSumLiteralTask";
import * as SquareOfDifferenceTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/SquareOfDifferenceTask";
import * as DifferenceOfSquaresTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/DifferenceOfSquaresTask";
import * as SquareOfSumTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/SquareOfSumTask";
import * as SquareOfDifferenceSqrtTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/SquareOfDifferenceSqrtTask";
import * as DifferenceOfSquaresWithRootTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/DifferenceOfSquaresWithRootTask";
import * as MixedSpecialProductsTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/MixedSpecialProductsTask";
import * as MixedSpecialProductsSqrtTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat2_wzory_skroconego_types/MixedSpecialProductsSqrtTask";
// generators/dzial2_algebra/temat1_wyrazenia/podtemat3_ulamki_algebraiczne_types
import * as DiffSquaresOverSumOrDiffTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat3_ulamki_algebraiczne_types/DiffSquaresOverSumOrDiffTask";
import * as CancelBracketFactorTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat3_ulamki_algebraiczne_types/CancelBracketFactorTask";
import * as MultiplyAndSimplifyRationalTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat3_ulamki_algebraiczne_types/MultiplyAndSimplifyRationalTask";
import * as DiffSquaresOverSquareExpandedTask from "../../generators/dzial2_algebra/temat1_wyrazenia/podtemat3_ulamki_algebraiczne_types/DiffSquaresOverSquareExpandedTask";



//generators/dzial2_algebra/temat2_rownania/podtemat1_liniowe_types
import * as SolveSimpleLinearEquationTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat1_liniowe_types/SolveSimpleLinearEquationTask";
import * as SolveTwoSidedLinearEquationTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat1_liniowe_types/SolveTwoSidedLinearEquationTask";
import * as SolveLinearEquationWithParenthesesTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat1_liniowe_types/SolveLinearEquationWithParenthesesTask";
import * as SolveQuadraticsThatReduceToLinearTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat1_liniowe_types/SolveQuadraticsThatReduceToLinearTask";
import * as EquationTypeIdentificationTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat1_liniowe_types/EquationTypeIdentificationTask";
import * as LinearEquationFractionsTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat1_liniowe_types/LinearEquationFractionsTask";
//generators/dzial2_algebra/temat2_rownania/podtemat2_kwadratowe_types
import * as SolveQuadraticWithoutBTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat2_kwadratowe_types/SolveQuadraticWithoutBTask";
import * as SolveQuadraticWithoutCTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat2_kwadratowe_types/SolveQuadraticWithoutCTask";
import * as SolveQuadraticTwoSolutionsTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat2_kwadratowe_types/SolveQuadraticTwoSolutionsTask";
import * as SolveRearrangedQuadraticTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat2_kwadratowe_types/SolveRearrangedQuadraticTask";
import * as QuadraticSolutionCountTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat2_kwadratowe_types/QuadraticSolutionCountTask";
import * as QuadraticCountAndSolveTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat2_kwadratowe_types/QuadraticCountAndSolveTask";
import * as ProductFactorsPolynomialEquationTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat5_wielomianowe_types/ProductFactorsPolynomialEquationTask";
import * as PolynomialRootCountTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat5_wielomianowe_types/PolynomialRootCountTask";

// generators/dzial2_algebra/temat2_rownania/podtemat3_wymierne_types
import * as RationalDomainLinearTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat3_wymierne_types/RationalDomainLinearTask";
import * as RationalSolveAndDomainLinearTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat3_wymierne_types/RationalSolveAndDomainLinearTask";
import * as RationalSolveAndDomainLinearConstTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat3_wymierne_types/RationalSolveAndDomainLinearConstTask";
import * as RationalTwoFracsSolveAndDomainTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat3_wymierne_types/RationalTwoFracsSolveAndDomainTask";
import * as RationalTwoFracsQuadraticTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat3_wymierne_types/RationalTwoFracsQuadraticTask";

//generators/dzial2_algebra/temat2_rownania/podtemat4_wartosci_bezwgledne_types
import * as SolveAbsoluteLinearTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat4_wartosci_bezwgledne_types/SolveAbsoluteLinearTask";
import * as SolveScaledShiftedAbsoluteLinearTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat4_wartosci_bezwgledne_types/SolveScaledShiftedAbsoluteLinearTask";
import * as CountSolutionsForAbsoluteTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat4_wartosci_bezwgledne_types/CountSolutionsForAbsoluteTask";
import * as SolveAbsoluteEqualityTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat4_wartosci_bezwgledne_types/SolveAbsoluteEqualityTask";
import * as AdvancedAbsoluteEquationTask from "../../generators/dzial2_algebra/temat2_rownania/podtemat6_wartosc_bezwzgledna_rozszerzenie_types/AdvancedAbsoluteEquationTask";
import * as LinearSystemSubstitutionEasyTask from "../../generators/dzial2_algebra/temat4_uklady/podtemat1_podstawianie_types/LinearSystemSubstitutionEasyTask";
import * as LinearSystemEliminationTask from "../../generators/dzial2_algebra/temat4_uklady/podtemat1_podstawianie_types/LinearSystemEliminationTask";
import * as LinearSystemSubstitutionFractionTask from "../../generators/dzial2_algebra/temat4_uklady/podtemat1_podstawianie_types/LinearSystemSubstitutionFractionTask";
import * as LinearSystemEliminationScaledTask from "../../generators/dzial2_algebra/temat4_uklady/podtemat1_podstawianie_types/LinearSystemEliminationScaledTask";
import * as LinearSystemSubstitutionNoUnitCoeffTask from "../../generators/dzial2_algebra/temat4_uklady/podtemat1_podstawianie_types/LinearSystemSubstitutionNoUnitCoeffTask";
import * as TwoNumbersSumDiffTask from "../../generators/dzial2_algebra/temat4_uklady/podtemat2_wspolczynniki_types/TwoNumbersSumDiffTask";
import * as TicketsSalesTask from "../../generators/dzial2_algebra/temat4_uklady/podtemat2_wspolczynniki_types/TicketsSalesTask";
import * as NestedPercentNumbersTask from "../../generators/dzial2_algebra/temat4_uklady/podtemat2_wspolczynniki_types/NestedPercentNumbersTask";
import * as LinearQuadraticSubstitutionTask from "../../generators/dzial2_algebra/temat4_uklady/podtemat3_liniowo_kwadratowe_types/LinearQuadraticSubstitutionTask";
import * as LinearQuadraticGraphIntersectionTask from "../../generators/dzial2_algebra/temat4_uklady/podtemat3_liniowo_kwadratowe_types/LinearQuadraticGraphIntersectionTask";


// generators/dzial2_algebra/temat3_nierownosci/podtemat1_liniowe_types
import * as LinearInequalitySimpleTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat1_liniowe_types/LinearInequalitySimpleTask";
import * as LinearInequalityTwoSidesTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat1_liniowe_types/LinearInequalityTwoSidesTask";
import * as LinearInequalityFractionsTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat1_liniowe_types/LinearInequalityFractionsTask";

// generators/dzial2_algebra/temat3_nierownosci/podtemat2_kwadratowe_types
import * as QuadraticFactoredInequalityTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat2_kwadratowe_types/QuadraticFactoredInequalityTask";
import * as QuadraticGeneralInequalityTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat2_kwadratowe_types/QuadraticGeneralInequalityTask";
import * as RearrangedQuadraticInequalityTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat2_kwadratowe_types/RearrangedQuadraticInequalityTask";
import * as QuadraticTwoSidesAllCasesTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat2_kwadratowe_types/QuadraticTwoSidesAllCasesTask";


// generators/dzial2_algebra/temat3_nierownosci/podtemat3_wartosc_bezwzgledna_types
import * as AbsLinearInequalityTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat3_wartosc_bezwzgledna_types/AbsLinearInequalityTask";
import * as AbsLinearInequalityShiftedScaledTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat3_wartosc_bezwzgledna_types/AbsLinearInequalityShiftedScaledTask";
import * as AbsLinearInequalityShiftedScaledAllCasesTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat3_wartosc_bezwzgledna_types/AbsLinearInequalityShiftedScaledAllCasesTask";
import * as AdvancedAbsoluteInequalityTask from "../../generators/dzial2_algebra/temat3_nierownosci/podtemat4_wartosc_bezwzgledna_rozszerzenie_types/AdvancedAbsoluteInequalityTask";


import * as ComputeFunctionValueTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat1_definicja_types/ComputeFunctionValueTask";
import * as ReadFunctionFromTableTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat1_definicja_types/ReadFunctionFromTableTask";
import * as PointOnGraphYesNoTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat1_definicja_types/PointOnGraphYesNoTask";
import * as LinearZeroTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat1_definicja_types/LinearZeroTask";
import * as IsRelationFunctionTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat1_definicja_types/IsRelationFunctionTask";
import * as LinearArgumentForValueTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat1_definicja_types/LinearArgumentForValueTask";
import * as LinearFunctionInequalityTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat1_definicja_types/LinearFunctionInequalityTask";

import * as ReadDomainFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadDomainFromGraphTask";
import * as ReadRangeFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadRangeFromGraphTask";
import * as ReadZeroFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadZeroFromGraphTask";
import * as ReadMonotonicityFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadMonotonicityFromGraphTask";
import * as ReadFunctionValueFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadFunctionValueFromGraphTask";
import * as ReadSignIntervalFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadSignIntervalFromGraphTask";
import * as ReadFunctionComparisonIntervalFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadFunctionComparisonIntervalFromGraphTask";
import * as ReadMaximumOnIntervalFromGraphTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadMaximumOnIntervalFromGraphTask";
import * as ReadGraphPropertiesCombinedTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat2_wykres_types/ReadGraphPropertiesCombinedTask";

import * as ShiftFunctionByVectorTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat3_przeksztalcenia_types/ShiftFunctionByVectorTask";
import * as ShiftVectorFromFormulaTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat3_przeksztalcenia_types/ShiftVectorFromFormulaTask";
import * as SymmetryFunctionTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat3_przeksztalcenia_types/SymmetryFunctionTask";
import * as SymmetryDomainRangeTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat3_przeksztalcenia_types/SymmetryDomainRangeTask";
import * as AbsoluteValueSetTransformTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat3_przeksztalcenia_types/AbsoluteValueSetTransformTask";
import * as AbsoluteValuePolylineSketchTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat3_przeksztalcenia_types/AbsoluteValuePolylineSketchTask";
import * as PolylineTransformSketchTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat3_przeksztalcenia_types/PolylineTransformSketchTask";
import * as ScaleGraphSketchTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat3_przeksztalcenia_types/ScaleGraphSketchTask";
import * as ScaleSetTransformTask from "../../generators/dzial3_funkcje/temat1_wlasnosci/podtemat3_przeksztalcenia_types/ScaleSetTransformTask";


import * as LinearComputeValueTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat1_wzor_types/LinearComputeValueTask";
import * as LinearSlopeTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat1_wzor_types/LinearSlopeTask";
import * as LinearInterceptTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat1_wzor_types/LinearInterceptTask";
import * as LinearFromTwoPointsTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat1_wzor_types/LinearFromTwoPointsTask";

import * as LinearValueFromGraphTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat2_wykres_types/LinearValueFromGraphTask";
import * as LinearZeroFromGraphTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat2_wykres_types/LinearZeroFromGraphTask";
import * as LinearSignFromGraphTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat2_wykres_types/LinearSignFromGraphTask";
import * as LinearEquationFromGraphTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat2_wykres_types/LinearEquationFromGraphTask";
import * as LinearIntersectionFromGraphTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat2_wykres_types/LinearIntersectionFromGraphTask";
import * as LinearTextDirectProportionTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat3_tekstowe_types/LinearTextDirectProportionTask";
import * as LinearTextTaxiFareTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat3_tekstowe_types/LinearTextTaxiFareTask";
import * as LinearTextFuelRemainingTask from "../../generators/dzial3_funkcje/temat2_liniowa/podtemat3_tekstowe_types/LinearTextFuelRemainingTask";
import * as LinearDerivativeTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat1_pochodna_types/LinearDerivativeTask";
import * as PolynomialDerivativeTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat1_pochodna_types/PolynomialDerivativeTask";
import * as ProductDerivativeTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat1_pochodna_types/ProductDerivativeTask";
import * as QuotientDerivativeTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat1_pochodna_types/QuotientDerivativeTask";
import * as QuadraticMonotonicityTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat3_ekstrema_types/QuadraticMonotonicityTask";
import * as CubicMonotonicityTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat3_ekstrema_types/CubicMonotonicityTask";
import * as RationalPolynomialDerivativeTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat1_pochodna_types/RationalPolynomialDerivativeTask";
import * as RadicalDerivativeTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat1_pochodna_types/RadicalDerivativeTask";
import * as QuadraticTangentTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat2_styczna_types/QuadraticTangentTask";
import * as QuadraticTangentBySlopeTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat2_styczna_types/QuadraticTangentBySlopeTask";
import * as PolynomialTangentTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat2_styczna_types/PolynomialTangentTask";
import * as RationalTangentTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat2_styczna_types/RationalTangentTask";
import * as QuadraticExtremumTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat3_ekstrema_types/QuadraticExtremumTask";
import * as CubicLocalExtremumTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat3_ekstrema_types/CubicLocalExtremumTask";
import * as QuarticGlobalExtremumTask from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat3_ekstrema_types/QuarticGlobalExtremumTask";

// generators/dzial3_funkcje/temat3_kwadratowa/podtemat1_ogolna_types
import * as FindQuadraticCoefficientsTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat1_ogolna_types/FindQuadraticCoefficientsTask";
import * as FindVertexFromGeneralTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat1_ogolna_types/FindVertexFromGeneralTask";
import * as DeltaAndZerosCountTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat1_ogolna_types/DeltaAndZerosCountTask";
import * as FindRootsFromGeneralTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat1_ogolna_types/FindRootsFromGeneralTask";
import * as PlotQuadraticSpecialPointsTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat1_ogolna_types/PlotQuadraticSpecialPointsTask";

// generators/dzial3_funkcje/temat3_kwadratowa/podtemat2_kanoniczna_types
import * as TransformGeneralToCanonicalTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat2_kanoniczna_types/TransformGeneralToCanonicalTask";
import * as TransformCanonicalToGeneralTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat2_kanoniczna_types/TransformCanonicalToGeneralTask";
import * as FindAPQFromCanonicalTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat2_kanoniczna_types/FindAPQFromCanonicalTask";

// generators/dzial3_funkcje/temat3_kwadratowa/podtemat3_iloczynowa_types
import * as FindAX1X2FromFactoredTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat3_iloczynowa_types/FindAX1X2FromFactoredTask";
import * as TransformGeneralToFactoredTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat3_iloczynowa_types/TransformGeneralToFactoredTask";
import * as TransformFactoredToGeneralTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat3_iloczynowa_types/TransformFactoredToGeneralTask";

// generators/dzial3_funkcje/temat3_kwadratowa/podtemat4_optymalizacja_types
import * as OptimizationPairsTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat4_optymalizacja_types/OptimizationPairsTask";
import * as QuadraticExtremeArgTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat4_optymalizacja_types/QuadraticExtremeArgTask";
import * as QuadraticExtremeValueTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat4_optymalizacja_types/QuadraticExtremeValueTask";
import * as QuadraticExtremeOnIntervalTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat4_optymalizacja_types/QuadraticExtremeOnIntervalTask";
import * as FenceMaxAreaAgainstWallTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat4_optymalizacja_types/FenceMaxAreaAgainstWallTask";
import * as ProfitOptimizationStoryTask from "../../generators/dzial3_funkcje/temat3_kwadratowa/podtemat4_optymalizacja_types/ProfitOptimizationStoryTask";

// 4.Ciągi
import * as FindNthTermFromLinearTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat1_definicja_types/FindNthTermFromFormulaTask";
import * as FindNthTermFromQuadraticTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat1_definicja_types/FindNthTermFromFormulaTask";
import * as FindNthTermFromExponentialTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat1_definicja_types/FindNthTermFromFormulaTask";
import * as FindNthTermFromRationalTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat1_definicja_types/FindNthTermFromFormulaTask";
import * as SumInitialTermsFromFormulaTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat1_definicja_types/SumInitialTermsFromFormulaTask";

import * as CheckMonotonicityGivenSequenceTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat2_monotonicznosc_types/CheckMonotonicityGivenSequenceTask";
import * as ComputeNextTermLinearTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat2_monotonicznosc_types/ComputeNextTermLinearTask";
import * as CheckMonotonicityFromDifferenceTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat2_monotonicznosc_types/CheckMonotonicityFromDifferenceTask";

import * as CompleteRecursiveTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat3_rekurencyjny_types/CompleteRecursiveTask";
import * as RecursiveQuadraticTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat3_rekurencyjny_types/RecursiveQuadraticTask";
import * as RecursiveTwoStepTask from "../../generators/dzial4_ciagi/temat1_ciag_wprowadzenie/podtemat3_rekurencyjny_types/RecursiveTwoStepTask";


import * as FindNthTermTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat1_wzor_ogolny_types/FindNthTermTask";
import * as FindDifferenceTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat1_wzor_ogolny_types/FindDifferenceTask";
import * as FindTermIndexTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat1_wzor_ogolny_types/FindTermIndexTask";
import * as FindA1AndRTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat1_wzor_ogolny_types/FindA1AndRTask";
import * as ArithmeticMiddleTermTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat1_wzor_ogolny_types/ArithmeticMiddleTermTask";
import * as ArithmeticMiddleTermEquationTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat1_wzor_ogolny_types/ArithmeticMiddleTermEquationTask";


import * as FindSumTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat2_suma_types/FindSumTask";
import * as FindNFromSumTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat2_suma_types/FindNFromSumTask";
import * as FindA1FromSumTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat2_suma_types/FindA1FromSumTask";
import * as FindRFromSumTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat2_suma_types/FindRFromSumTask";

import * as FindLoanInstallmentsTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat3_tekstowe_types/FindLoanInstallmentsTask";
import * as FindCountDivisibleTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat3_tekstowe_types/FindCountDivisibleTask";
import * as Find3TermArithmeticTask from "../../generators/dzial4_ciagi/temat2_ciag_arytmetyczny/podtemat3_tekstowe_types/Find3TermArithmeticTask";


import * as FindNthTermGeoTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat1_wzor_ogolny_types/FindNthTermGeoTask";
import * as FindRatioGeoTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat1_wzor_ogolny_types/FindRatioGeoTask";
import * as FindTermIndexGeoTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat1_wzor_ogolny_types/FindTermIndexGeoTask";
import * as FindA1AndQGeoTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat1_wzor_ogolny_types/FindA1AndQGeoTask";
import * as FindNthTermGeoFracTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat1_wzor_ogolny_types/FindNthTermGeoFracTask";
import * as GeometricConsecutiveRatioTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat1_wzor_ogolny_types/GeometricConsecutiveRatioTask";
import * as GeometricMiddleTermTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat1_wzor_ogolny_types/GeometricMiddleTermTask";


import * as FindSumGeoTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat2_suma_types/FindSumGeoTask";
import * as FindA1FromSumGeoTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat2_suma_types/FindA1FromSumGeoTask";
import * as FindQFromSumGeoTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat2_suma_types/FindQFromSumGeoTask";
import * as FindNFromSumGeoTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat2_suma_types/FindNFromSumGeoTask";
import * as FindSumGeoNegQTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat2_suma_types/FindSumGeoNegQTask";


import * as FindFinalAmountSimpleInterestTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat3_procent_types/FindFinalAmountSimpleInterestTask";
import * as FindFinalAmountSingleCapitalizationTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat3_procent_types/FindFinalAmountSingleCapitalizationTask";
import * as FindFinalAmountMultipleCapitalizationTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat3_procent_types/FindFinalAmountMultipleCapitalizationTask";
import * as FindFinalAmountWithTaxTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat3_procent_types/FindFinalAmountWithTaxTask";

import * as FindDailyInfectionTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat4_tekstowe_types/FindDailyInfectionTask";
import * as FindViralReachTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat4_tekstowe_types/FindViralReachTask";
import * as FindXForGeometricTripletTask from "../../generators/dzial4_ciagi/temat3_ciag_geometryczny/podtemat4_tekstowe_types/FindXForGeometricTripletTask";

import * as FindSinFromTriangleTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat1_definicje_trojkat_types/FindSinFromTriangleTask";
import * as FindCosFromTriangleTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat1_definicje_trojkat_types/FindCosFromTriangleTask";
import * as FindTanFromTriangleTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat1_definicje_trojkat_types/FindTanFromTriangleTask";
import * as IdentifyTrigRatioFromTriangleTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat1_definicje_trojkat_types/IdentifyTrigRatioFromTriangleTask";

import * as FindTriangleFromSinTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat5_rozwiazywanie_trojkata_types/FindTriangleFromSinTask";
import * as FindTriangleFromCosTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat5_rozwiazywanie_trojkata_types/FindTriangleFromCosTask";
import * as FindTriangleFromTanTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat5_rozwiazywanie_trojkata_types/FindTriangleFromTanTask";


import * as TrigValueFromAngleTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat2_wartosci_funkcji_types/TrigValueFromAngleTask";
import * as MultiplyTrigFunctionsTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat2_wartosci_funkcji_types/MultiplyTrigFunctionsTask";
import * as AddOrSubtractTrigFunctionsTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat2_wartosci_funkcji_types/AddOrSubtractTrigFunctionsTask";
import * as ApproximateTrigValueTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat2_wartosci_funkcji_types/ApproximateTrigValueTask";

import * as InclinedRoadElevationTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat3_zastosowania_types/InclinedRoadElevationTask";
import * as LighthouseRangeTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat3_zastosowania_types/LighthouseRangeTask";
import * as TreeShadowTask from "../../generators/dzial5_trygonometria/temat1_wprowadzenie/podtemat3_zastosowania_types/TreeShadowTask";

import * as FindSinFromPointTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat1_definicja_uklad_types/FindSinFromPointTask";
import * as FindCosFromPointTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat1_definicja_uklad_types/FindCosFromPointTask";
import * as FindTanFromPointTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat1_definicja_uklad_types/FindTanFromPointTask";

import * as ReduceSinExactTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat2_wzory_redukcyjne_types/ReduceSinExactTask";
import * as ReduceCosExactTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat2_wzory_redukcyjne_types/ReduceCosExactTask";
import * as ReduceTanExactTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat2_wzory_redukcyjne_types/ReduceTanExactTask";
import * as ReduceSinApproxTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat2_wzory_redukcyjne_types/ReduceSinApproxTask";
import * as ReduceCosApproxTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat2_wzory_redukcyjne_types/ReduceCosApproxTask";
import * as ReduceTanApproxTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat2_wzory_redukcyjne_types/ReduceTanApproxTask";

import * as GivenSinFindCosTanTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat3_tozsamosci_types/GivenSinFindCosTanTask";
import * as GivenCosFindSinTanTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat3_tozsamosci_types/GivenCosFindSinTanTask";
import * as GivenTanFindSinCosTask from "../../generators/dzial5_trygonometria/temat2_funkcje_rozszerzone/podtemat3_tozsamosci_types/GivenTanFindSinCosTask";
import * as TrigEquationIntroTask from "../../generators/dzial5_trygonometria/temat3_rownania_trygonometryczne/TrigEquationIntroTask";
import * as AdvancedTrigEquationTask from "../../generators/dzial5_trygonometria/temat3_rownania_trygonometryczne/AdvancedTrigEquationTask";

import * as FindCircumradiusFromSideAngleTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat8_twierdzenie_sinusow_types/FindCircumradiusFromSideAngleTask";
import * as FindSidesFromTwoAnglesAndOneSideTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat8_twierdzenie_sinusow_types/FindSidesFromTwoAnglesAndOneSideTask";
import * as FindAnglesFromTwoSidesAndOneAngleTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat8_twierdzenie_sinusow_types/FindAnglesFromTwoSidesAndOneAngleTask";

import * as FindSideFromTwoSidesAndIncludedAngleTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat9_twierdzenie_cosinusow_types/FindSideFromTwoSidesAndIncludedAngleTask";
import * as FindSideFromTwoSidesAndCosineTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat9_twierdzenie_cosinusow_types/FindSideFromTwoSidesAndCosineTask";
import * as FindAngleFromThreeSidesTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat9_twierdzenie_cosinusow_types/FindAngleFromThreeSidesTask";
import * as FindSideFromTwoSidesAndAdjacentAngleTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat9_twierdzenie_cosinusow_types/FindSideFromTwoSidesAndAdjacentAngleTask";

// Planimetria → Trójkąty
import * as ClassifyTriangleFromSidesTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat1_wlasnosci_i_klasyfikacja_types/ClassifyTriangleFromSidesTask";

import * as FindAreaFromBaseAndHeightTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat2_pole_trojkata_types/FindAreaFromBaseAndHeightTask";
import * as FindAreaFromTwoSidesAndAngleTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat2_pole_trojkata_types/FindAreaFromTwoSidesAndAngleTask";
import * as FindAreaHeronTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat2_pole_trojkata_types/FindAreaHeronTask";

import * as FindInradiusRightTriangleTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat3_okregi_w_trojkacie_types/FindInradiusRightTriangleTask";
import * as FindInradiusEquilateralTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat3_okregi_w_trojkacie_types/FindInradiusEquilateralTask";
import * as FindInradiusFromSidesTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat3_okregi_w_trojkacie_types/FindInradiusFromSidesTask";
import * as FindCircumradiusRightTriangleTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat3_okregi_w_trojkacie_types/FindCircumradiusRightTriangleTask";
import * as FindCircumradiusEquilateralTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat3_okregi_w_trojkacie_types/FindCircumradiusEquilateralTask";
import * as FindCircumradiusFromSidesTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat3_okregi_w_trojkacie_types/FindCircumradiusFromSidesTask";

import * as FindHypotenuseRightTriangleTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat4_trojkat_prostokatny_types/FindHypotenuseRightTriangleTask";
import * as ClassifyTriangleByAnglesOnlyTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat4_trojkat_prostokatny_types/ClassifyTriangleByAnglesOnlyTask";
import * as FindAltitudeToHypotenuseTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat4_trojkat_prostokatny_types/FindAltitudeToHypotenuseTask";

import * as FindHeightEquilateralTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat5_trojkat_rownoboczny_types/FindHeightEquilateralTask";
import * as FindAreaEquilateralTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat5_trojkat_rownoboczny_types/FindAreaEquilateralTask";
import * as FindAreaFromHeightEquilateralTask from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat5_trojkat_rownoboczny_types/FindAreaFromHeightEquilateralTask";

// Planimetria → Okrąg i koło (VI.3) → Podtemat 1
import * as FindCircleCircumferenceFromRadiusTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat1_elementy_pola_types/FindCircleCircumferenceFromRadiusTask";
import * as FindCircleAreaFromRadiusTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat1_elementy_pola_types/FindCircleAreaFromRadiusTask";
import * as FindArcLengthFromAngleTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat1_elementy_pola_types/FindArcLengthFromAngleTask";
import * as FindSectorAreaFromAngleTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat1_elementy_pola_types/FindSectorAreaFromAngleTask";
import * as FindAnnulusAreaFromRadiiTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat1_elementy_pola_types/FindAnnulusAreaFromRadiiTask";

// Planimetria → Okrąg i koło (VI.3) → Podtemat 2
import * as FindInscribedFromCentralAngleTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindInscribedFromCentralAngleTask";
import * as FindCentralFromInscribedAngleTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindCentralFromInscribedAngleTask";
import * as FindInscribedFromTangentChordTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindInscribedFromTangentChordTask";
import * as FindTangentChordMixTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindTangentChordMixTask";
import * as FindThirdAngleInInscribedTriangleTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindThirdAngleInInscribedTriangleTask";

import * as FindAngleInSemicircleTriangleTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindAngleInSemicircleTriangleTask";
import * as FindBaseAngleFromRadiiTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindBaseAngleFromRadiiTask";
import * as FindHiddenAngleInCircleTriangleTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindHiddenAngleInCircleTriangleTask";
import * as FindOppositeAngleInCyclicQuadrilateralTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat2_katy_styczne_types/FindOppositeAngleInCyclicQuadrilateralTask";
// Planimetria → Okrąg i koło (VI.3) → Podtemat 3
import * as FindTangentLengthTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat3_odcinki_types/FindTangentLengthTask";
import * as FindXFromEqualTangentsTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat3_odcinki_types/FindXFromEqualTangentsTask";
import * as FindPCFromSecantTangentTask from "../../generators/dzial6_planimetria/temat3_okrag_i_kolo/podtemat3_odcinki_types/FindPCFromSecantTangentTask";
// Planimetria → Czworokąty (VI.2) → Podtemat 1: Prostokąty i kwadraty
import * as RectanglePerimeterFromSidesTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat1_prostokaty_kwadraty_types/RectanglePerimeterFromSidesTask";
import * as RectangleDiagonalFromSidesTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat1_prostokaty_kwadraty_types/RectangleDiagonalFromSidesTask";
import * as SquareAreaFromSideTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat1_prostokaty_kwadraty_types/SquareAreaFromSideTask";
import * as SquareDiagonalFromSideTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat1_prostokaty_kwadraty_types/SquareDiagonalFromSideTask";
import * as SquarePerimeterFromSideTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat1_prostokaty_kwadraty_types/SquarePerimeterFromSideTask";
import * as RectangleAreaFromSidesTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat1_prostokaty_kwadraty_types/RectangleAreaFromSidesTask";

// Planimetria → Czworokąty (VI.2) → Podtemat 2: Równoległoboki i romby
import * as ParallelogramPerimeterFromSidesTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat2_rownolegoboki_romby_types/ParallelogramPerimeterFromSidesTask";
import * as ParallelogramAreaFromSideAndHeightTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat2_rownolegoboki_romby_types/ParallelogramAreaFromSideAndHeightTask";
import * as ParallelogramAreaFromSidesAndAngleTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat2_rownolegoboki_romby_types/ParallelogramAreaFromSidesAndAngleTask";

import * as RhombusPerimeterFromSideTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat2_rownolegoboki_romby_types/RhombusPerimeterFromSideTask";
import * as RhombusAreaFromDiagonalsTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat2_rownolegoboki_romby_types/RhombusAreaFromDiagonalsTask";

// Planimetria → Czworokąty (VI.2) → Podtemat 3: Trapezy
import * as TrapezoidPerimeterFromSidesTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat3_trapezy_types/TrapezoidPerimeterFromSidesTask";
import * as TrapezoidAreaFromBasesAndHeightTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat3_trapezy_types/TrapezoidAreaFromBasesAndHeightTask";
import * as TrapezoidAreaIsoscelesFromSidesTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat3_trapezy_types/TrapezoidAreaIsoscelesFromSidesTask";
import * as TrapezoidHeightFromAreaAndBasesTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat3_trapezy_types/TrapezoidHeightFromAreaAndBasesTask";
import * as TrapezoidDiagonalRightTrapezoidTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat3_trapezy_types/TrapezoidDiagonalRightTrapezoidTask";
import * as TrapezoidRightOtherLegTask from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat3_trapezy_types/TrapezoidRightOtherLegTask";

// 7.Geometria analityczna
import { registry as InteractivePointTasksRegistry } from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat1_wspolrzedne_punktow";

import * as MidpointTask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat3_srodek_odcinka_types/MidpointTask";
import * as FindATask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat3_srodek_odcinka_types/FindATask";
import * as FindBTask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat3_srodek_odcinka_types/FindBTask";

import * as LengthTask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat2_odleglosc_types/LengthTask";
import * as PerimeterTask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat2_odleglosc_types/PerimeterTask";

import * as SymmetryXTask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat4_symetria_types/SymmetryXTask";
import * as SymmetryYTask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat4_symetria_types/SymmetryYTask";
import * as SymmetrySegmentTask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat4_symetria_types/SymmetrySegmentTask";
import * as SymmetryCircleTask from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat4_symetria_types/SymmetryCircleTask";

import * as FindSlopeTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat1_postac_kierunkowa_types/FindSlopeTask";
import * as FindYInterceptTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat1_postac_kierunkowa_types/FindYInterceptTask";
import * as FindLineTwoPointsTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat1_postac_kierunkowa_types/FindLineTwoPointsTask";
import * as SignOfLineTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat1_postac_kierunkowa_types/SignOfLineTask";

import * as ConvertGeneralToSlopeTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat2_postac_ogolna_types/ConvertGeneralToSlopeTask";
import * as ConvertSlopeToGeneralTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat2_postac_ogolna_types/ConvertSlopeToGeneralTask";
import * as FindGeneralLineTwoPointsTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat2_postac_ogolna_types/FindGeneralLineTwoPointsTask";
import * as DistancePointLineTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat2_postac_ogolna_types/DistancePointLineTask";

import * as ParallelLineThroughPointTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat3_wzajemne_polozenie_types/ParallelLineThroughPointTask";
import * as PerpendicularLineThroughPointTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat3_wzajemne_polozenie_types/PerpendicularLineThroughPointTask";
import * as FindParameterParallelTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat3_wzajemne_polozenie_types/FindParameterParallelTask";
import * as FindParameterPerpendicularTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat3_wzajemne_polozenie_types/FindParameterPerpendicularTask";
import * as IntersectionAnalysisTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat3_wzajemne_polozenie_types/IntersectionAnalysisTask";
import * as PerpendicularBisectorTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat3_wzajemne_polozenie_types/PerpendicularBisectorTask";
import * as FindParameterGeneralLineRelationTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat3_wzajemne_polozenie_types/FindParameterGeneralLineRelationTask";
import * as FindParameterGeneralPerpendicularTask from "../../generators/dzial7_geometria_analityczna/temat2_prosta/podtemat3_wzajemne_polozenie_types/FindParameterGeneralPerpendicularTask";

import * as ReadCircleFromEquationTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat1_kanoniczna_types/ReadCircleFromEquationTask";
import * as WriteCircleEquationTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat1_kanoniczna_types/WriteCircleEquationTask";
import * as WriteCircleFromCenterAndPointTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat1_kanoniczna_types/WriteCircleFromCenterAndPointTask";
import * as WriteCircleFromDiameterTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat1_kanoniczna_types/WriteCircleFromDiameterTask";

import * as ConvertToCanonicalTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat2_ogolna_types/ConvertToCanonicalTask";
import * as ReadCenterRadiusFromGeneralTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat2_ogolna_types/ReadCenterRadiusFromGeneralTask";
import * as ClassifyCircleFromGeneralTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat2_ogolna_types/ClassifyCircleFromGeneralTask";

import * as CheckPointCirclePositionTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat3_wzajemne_polozenie_types/CheckPointCirclePositionTask";
import * as LineCirclePositionTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat3_wzajemne_polozenie_types/LineCirclePositionTask";
import * as TriangleCoordinateTasks from "../../generators/dzial7_geometria_analityczna/temat4_figury_w_ukladzie/TriangleCoordinateTasks";
import * as FindIntersectionPointsTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat3_wzajemne_polozenie_types/FindIntersectionPointsTask";
import * as FindCircleCircleIntersectionPointsTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat3_wzajemne_polozenie_types/FindCircleCircleIntersectionPointsTask";
import * as CircleCirclePositionTask from "../../generators/dzial7_geometria_analityczna/temat3_okrag/podtemat3_wzajemne_polozenie_types/CircleCirclePositionTask";


// Dział 8
import * as CountElementsTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat1_wlasciwosci_graniastoslupow_types/CountElementsTask";
import * as CountFromGivenElementTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat1_wlasciwosci_graniastoslupow_types/CountFromGivenElementTask";
import * as CubeDiagonalTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat1_wlasciwosci_graniastoslupow_types/CubeDiagonalTask";
import * as PrismDiagonalTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat1_wlasciwosci_graniastoslupow_types/PrismDiagonalTask";

import * as LateralSurfaceTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat2_pole_powierzchni_graniastoslupow_types/LateralSurfaceTask";
import * as ReverseLateralSurfaceTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat2_pole_powierzchni_graniastoslupow_types/ReverseLateralSurfaceTask";
import * as TotalSurfaceTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat2_pole_powierzchni_graniastoslupow_types/TotalSurfaceTask";
import * as ReverseTotalSurfaceTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat2_pole_powierzchni_graniastoslupow_types/ReverseTotalSurfaceTask";
import * as CuboidVolumeTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat3_objetosc_graniastoslupow_types/CuboidVolumeTask";
import * as RegularPrismVolumeTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat3_objetosc_graniastoslupow_types/RegularPrismVolumeTask";
import * as InverseRegularPrismDimensionTask from "../../generators/dzial8_stereometria/temat1_graniastoslupy/podtemat3_objetosc_graniastoslupow_types/InverseRegularPrismDimensionTask";


// Dział 8 → Stereometria → Temat 2: Ostrosłupy → Podtemat 1: Własności i klasyfikacja
import * as CountElementsFromBaseTask from "../../generators/dzial8_stereometria/temat2_ostroslupy/podtemat1_wlasnosci_i_klasyfikacja_types/CountElementsFromBaseTask";
import * as ConvertElementsCountsTask from "../../generators/dzial8_stereometria/temat2_ostroslupy/podtemat1_wlasnosci_i_klasyfikacja_types/ConvertElementsCountsTask";
import * as BaseAreaOfRegularPyramidTask from "../../generators/dzial8_stereometria/temat2_ostroslupy/podtemat1_wlasnosci_i_klasyfikacja_types/BaseAreaOfRegularPyramidTask";
import * as LateralEdgeFromHeight_SquareRegularPyramidTask from "../../generators/dzial8_stereometria/temat2_ostroslupy/podtemat1_wlasnosci_i_klasyfikacja_types/LateralEdgeFromHeight_SquareRegularPyramidTask";
import * as LateralEdgeFromHeight_TriangleRegularPyramidTask from "../../generators/dzial8_stereometria/temat2_ostroslupy/podtemat1_wlasnosci_i_klasyfikacja_types/LateralEdgeFromHeight_TriangleRegularPyramidTask";
import * as PyramidVolumeFromBaseAreaTask from "../../generators/dzial8_stereometria/temat2_ostroslupy/podtemat3_objetosc_ostroslupow_types/PyramidVolumeFromBaseAreaTask";
import * as PyramidHeightFromVolumeTask from "../../generators/dzial8_stereometria/temat2_ostroslupy/podtemat3_objetosc_ostroslupow_types/PyramidHeightFromVolumeTask";
import * as PyramidBaseAreaFromVolumeTask from "../../generators/dzial8_stereometria/temat2_ostroslupy/podtemat3_objetosc_ostroslupow_types/PyramidBaseAreaFromVolumeTask";
import * as RegularSquarePyramidVolumeTask from "../../generators/dzial8_stereometria/temat2_ostroslupy/podtemat3_objetosc_ostroslupow_types/RegularSquarePyramidVolumeTask";
import * as RightTriangleBasePyramidVolumeTask from "../../generators/dzial8_stereometria/temat2_ostroslupy/podtemat3_objetosc_ostroslupow_types/RightTriangleBasePyramidVolumeTask";



// Dział 8 → Stereometria → Temat 3: Bryły obrotowe → Podtemat 1: Walec
import * as LateralSurfaceAreaOfCylinderTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat1_walec_types/LateralSurfaceAreaOfCylinderTask";
import * as TotalSurfaceAreaOfCylinderTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat1_walec_types/TotalSurfaceAreaOfCylinderTask";
import * as VolumeOfCylinderTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat1_walec_types/VolumeOfCylinderTask";
import * as ConeVolumeTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat2_stozek_types/ConeVolumeTask";
import * as ConeLateralSurfaceAreaTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat2_stozek_types/ConeLateralSurfaceAreaTask";
import * as ConeTotalSurfaceAreaTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat2_stozek_types/ConeTotalSurfaceAreaTask";
import * as ConeHeightFromVolumeTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat2_stozek_types/ConeHeightFromVolumeTask";
import * as SphereSurfaceAreaTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat3_kula_types/SphereSurfaceAreaTask";
import * as SphereVolumeTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat3_kula_types/SphereVolumeTask";
import * as SphereRadiusFromSurfaceAreaTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat3_kula_types/SphereRadiusFromSurfaceAreaTask";
import * as SphereRadiusFromVolumeTask from "../../generators/dzial8_stereometria/temat3_bryly_obrotowe/podtemat3_kula_types/SphereRadiusFromVolumeTask";
import * as SimilarSolidVolumeFromLengthScaleTask from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat1_uzupelniajace_types/SimilarSolidVolumeFromLengthScaleTask";
import * as SimilarSolidVolumeFromAreaScaleTask from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat1_uzupelniajace_types/SimilarSolidVolumeFromAreaScaleTask";
import * as SimilarSolidAreaFromVolumeScaleTask from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat1_uzupelniajace_types/SimilarSolidAreaFromVolumeScaleTask";


// Kombinatoryka — Podstawy
import * as OutfitMultiplicationTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat1_podstawy_types/OutfitMultiplicationTask";
import * as AdditionOfProductsMealTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat1_podstawy_types/AdditionOfProductsMealTask";
import * as DigitOnceBelowH00Task from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat1_podstawy_types/DigitOnceBelowH00Task";
import * as DigitOnceBelowNTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat1_podstawy_types/DigitOnceBelowNTask";


// Kombinatoryka — Permutacje
import * as PermutationRaceTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat2_permutacje_types/PermutationRaceTask";
import * as PermutationWithRepetitionTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat2_permutacje_types/PermutationWithRepetitionTask";
import * as CinemaAdjacentPairTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat2_permutacje_types/CinemaAdjacentPairTask";


// Kombinatoryka — Wariacje
import * as VariationCodeTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat3_wariacje_types/VariationCodeTask";
import * as VariationKDigitNumbersTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat3_wariacje_types/VariationKDigitNumbersTask";
import * as VariationNoRepeatBooksTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat3_wariacje_types/VariationNoRepeatBooksTask";

// Kombinatoryka — Kombinacje
import * as CombinationTeamTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat4_kombinacje_types/CombinationTeamTask";
import * as CombinationBouquetTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat4_kombinacje_types/CombinationBouquetTask";
import * as CombinationTeamAtLeastOneFromEachTask from "../../generators/dzial9_prawdopodobienstwo/temat1_kombinatoryka/podtemat4_kombinacje_types/CombinationTeamAtLeastOneFromEachTask";

// Rachunek prawdopodobieństwa — Podstawy (9.2.1)
import * as DiceSingleRollTask from "../../generators/dzial9_prawdopodobienstwo/temat2_rachunek/podtemat1_podstawy_types/DiceSingleRollTask";
import * as TwoDiceSumGreaterTask from "../../generators/dzial9_prawdopodobienstwo/temat2_rachunek/podtemat1_podstawy_types/TwoDiceSumGreaterTask";
import * as UrnOneDrawTask from "../../generators/dzial9_prawdopodobienstwo/temat2_rachunek/podtemat1_podstawy_types/UrnOneDrawTask";
import * as LotteryOneDrawTask from "../../generators/dzial9_prawdopodobienstwo/temat2_rachunek/podtemat1_podstawy_types/LotteryOneDrawTask";

// Rachunek prawdopodobieństwa — Zastosowania kombinatoryki (9.2.2)
import * as UrnTwoDrawsTask from "../../generators/dzial9_prawdopodobienstwo/temat2_rachunek/podtemat2_zastosowaniaKombinatoryki_types/UrnTwoDrawsTask";
import * as CardsTwoDrawsTask from "../../generators/dzial9_prawdopodobienstwo/temat2_rachunek/podtemat2_zastosowaniaKombinatoryki_types/CardsTwoDrawsTask";
import * as CoinTossesTask from "../../generators/dzial9_prawdopodobienstwo/temat2_rachunek/podtemat2_zastosowaniaKombinatoryki_types/CoinTossesTask";

// Statystyka opisowa — Średnie (9.1.1)
import * as MeanArithmeticRawTask from "../../generators/dzial9_prawdopodobienstwo/temat1_statystyka_opisowa/podtemat1_srednie_types/MeanArithmeticRawTask";
import * as MeanArithmeticWithUnknownTask from "../../generators/dzial9_prawdopodobienstwo/temat1_statystyka_opisowa/podtemat1_srednie_types/MeanArithmeticWithUnknownTask";
import * as MeanGeometricRawTask from "../../generators/dzial9_prawdopodobienstwo/temat1_statystyka_opisowa/podtemat1_srednie_types/MeanGeometricRawTask";
import * as MeanWeightedDiaryTask from "../../generators/dzial9_prawdopodobienstwo/temat1_statystyka_opisowa/podtemat1_srednie_types/MeanWeightedDiaryTask";
// Statystyka opisowa — Miary położenia i zmienności (9.1.2)
import * as MedianTask from "../../generators/dzial9_prawdopodobienstwo/temat1_statystyka_opisowa/podtemat2_miary_polozenia_i_zmiennosci_types/MedianTask";
import * as ModeTask from "../../generators/dzial9_prawdopodobienstwo/temat1_statystyka_opisowa/podtemat2_miary_polozenia_i_zmiennosci_types/ModeTask";
import * as StdDeviationTask from "../../generators/dzial9_prawdopodobienstwo/temat1_statystyka_opisowa/podtemat2_miary_polozenia_i_zmiennosci_types/StdDeviationTask";

// Dział 11 — Szkoła podstawowa → Ułamki dziesiętne
import * as DecimalAdditionMemoryNoCarryTask from "../../generators/dzial11_szkola_podstawowa/temat1_ulamki_dziesietne/podtemat1_dodawanie_odejmowanie_types/DecimalAdditionMemoryNoCarryTask";
import * as DecimalAdditionMemoryCarryTask from "../../generators/dzial11_szkola_podstawowa/temat1_ulamki_dziesietne/podtemat1_dodawanie_odejmowanie_types/DecimalAdditionMemoryCarryTask";
import * as DecimalSubtractionMemoryNoBorrowTask from "../../generators/dzial11_szkola_podstawowa/temat1_ulamki_dziesietne/podtemat1_dodawanie_odejmowanie_types/DecimalSubtractionMemoryNoBorrowTask";
import * as DecimalSubtractionMemoryBorrowTask from "../../generators/dzial11_szkola_podstawowa/temat1_ulamki_dziesietne/podtemat1_dodawanie_odejmowanie_types/DecimalSubtractionMemoryBorrowTask";
import * as DecimalAdditionTask from "../../generators/dzial11_szkola_podstawowa/temat1_ulamki_dziesietne/podtemat1_dodawanie_odejmowanie_types/DecimalAdditionTask";
import * as DecimalAdditionVariableTask from "../../generators/dzial11_szkola_podstawowa/temat1_ulamki_dziesietne/podtemat1_dodawanie_odejmowanie_types/DecimalAdditionVariableTask";
import * as DecimalSubtractionTask from "../../generators/dzial11_szkola_podstawowa/temat1_ulamki_dziesietne/podtemat1_dodawanie_odejmowanie_types/DecimalSubtractionTask";
import * as DecimalSubtractionVariableTask from "../../generators/dzial11_szkola_podstawowa/temat1_ulamki_dziesietne/podtemat1_dodawanie_odejmowanie_types/DecimalSubtractionVariableTask";
import * as DecimalAddSubtractTask from "../../generators/dzial11_szkola_podstawowa/temat1_ulamki_dziesietne/podtemat1_dodawanie_odejmowanie_types/DecimalAddSubtractTask";
import * as DecimalMultiplyByOneDigitTask from "../../generators/dzial11_szkola_podstawowa/temat1_ulamki_dziesietne/podtemat2_mnozenie_types/DecimalMultiplyByOneDigitTask";
import * as DecimalDivisionTask from "../../generators/dzial11_szkola_podstawowa/temat1_ulamki_dziesietne/podtemat3_dzielenie_types/DecimalDivisionTask";
import * as DecimalRoundingTask from "../../generators/dzial11_szkola_podstawowa/temat1_ulamki_dziesietne/podtemat4_szacowanie_types/DecimalRoundingTask";
import * as DecimalEstimateTask from "../../generators/dzial11_szkola_podstawowa/temat1_ulamki_dziesietne/podtemat4_szacowanie_types/DecimalEstimateTask";





import { registry as FormulaSubstitutionTasksRegistry } from "../../generators/dzial2_algebra/temat6_wzory_i_zaleznosci/podtemat1_podstawianie_do_wzorow";
import { registry as FormulaTransformTasksRegistry } from "../../generators/dzial2_algebra/temat6_wzory_i_zaleznosci/podtemat2_przeksztalcanie_wzorow";
import { registry as SpeedDistanceTimeTasksRegistry } from "../../generators/dzial2_algebra/temat6_wzory_i_zaleznosci/podtemat3_predkosc_droga_czas";
import { registry as PolynomialBasicsTasksRegistry } from "../../generators/dzial2_algebra/temat7_wielomiany/podtemat1_pojecie";
import { registry as ScaleTasksRegistry } from "../../generators/dzial6_planimetria/temat5_skala_i_podobienstwo/podtemat1_skala";
import { registry as SimilarityTasksRegistry } from "../../generators/dzial6_planimetria/temat5_skala_i_podobienstwo/podtemat2_podobienstwo";
import { registry as ScaleAreaVolumeTasksRegistry } from "../../generators/dzial6_planimetria/temat5_skala_i_podobienstwo/podtemat3_pola_objetosci";
import { registry as UnitConversionTasksRegistry } from "../../generators/dzial6_planimetria/temat5_skala_i_podobienstwo/podtemat4_jednostki";
import { registry as KatyWTrojkatachTasksRegistry } from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat6_katy_w_trojkatach";
import { registry as AngleRelationsTasksRegistry } from "../../generators/dzial6_planimetria/temat6_katy/podtemat1_zaleznosci_miedzy_katami";
import { registry as KatyWCzworokatachTasksRegistry } from "../../generators/dzial6_planimetria/temat2_czworokaty/podtemat4_katy_czworokatow";
import { registry as AnalyticVectorTasksRegistry } from "../../generators/dzial7_geometria_analityczna/temat1_punkty_odcinki/podtemat5_wektory";
import { registry as E8NumberOpenRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat5_e8_otwarte";
import { registry as E8NumberClosedRegistry } from "../../generators/dzial1_liczby_i_dzialania/temat6_zadania_uzupelniajace_maturalne/podtemat4_e8_zamkniete";
import { registry as E8AlgebraOpenRegistry } from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat6_e8_otwarte";
import { registry as E8AlgebraClosedRegistry } from "../../generators/dzial2_algebra/temat5_zadania_uzupelniajace_maturalne/podtemat5_e8_zamkniete";
import { registry as E8PlanimetryOpenRegistry } from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat4_e8_otwarte";
import { registry as E8PlanimetryClosedRegistry } from "../../generators/dzial6_planimetria/temat4_zadania_uzupelniajace_maturalne/podtemat5_e8_zamkniete";
import { registry as E8AnalyticClosedRegistry } from "../../generators/dzial7_geometria_analityczna/temat4_zadania_uzupelniajace_maturalne/podtemat4_e8_zamkniete";
import { registry as E8StereometryClosedRegistry } from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat5_e8_zamkniete";
import { registry as E8StereometryOpenRegistry } from "../../generators/dzial8_stereometria/temat4_zadania_uzupelniajace_maturalne/podtemat4_e8_otwarte";
import { registry as E8ProbabilityClosedRegistry } from "../../generators/dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat5_e8_zamkniete";
import { talesPodobienstwoRegistry as ThalesSimilarityRegistry } from "../../generators/dzial6_planimetria/temat1_trojkaty/podtemat7_tales_i_podobienstwo";
import { registry as FunctionAnalysisOptimizationRegistry } from "../../generators/dzial3_funkcje/temat7_analiza_matematyczna/podtemat4_optymalizacja";
import { registry as ProbabilityEventsRegistry } from "../../generators/dzial9_prawdopodobienstwo/temat2_rachunek/podtemat3_zdarzenia";

export const quizTypeRegistry = {
  ...OddRootsRegistry,
  ...FactorSumRegistry,
  ...InverseInterestRegistry,

  ...BasicRootOperationsRegistry,
  ...FractionRootProductsRegistry,
  ...OrderOfOperationsRegistry,
  ...RomanNumeralsRegistry,
  ...NaturalAddSubtractRegistry,
  ...NaturalMultiplicationRegistry,
  ...NaturalDivisionRegistry,
  ...IntegerNumberLineRegistry,
  ...IntegerAddSubtractRegistry,
  ...IntegerMultiplicationRegistry,
  ...IntegerDivisionRegistry,
  ...FractionSimplifyingRegistry,
  ...FractionComparingRegistry,
  ...FractionAddSubtractRegistry,
  ...FractionMultiplicationRegistry,
  ...FractionDivisionRegistry,
  ...MixedNumbersRegistry,
  ...FractionCombinedRationalRegistry,
  ...E8NumberOpenRegistry,
  ...E8NumberClosedRegistry,
  ...E8AlgebraOpenRegistry,
  ...E8AlgebraClosedRegistry,
  ...E8PlanimetryOpenRegistry,
  ...E8PlanimetryClosedRegistry,
  ...E8AnalyticClosedRegistry,
  ...E8StereometryClosedRegistry,
  ...E8StereometryOpenRegistry,
  ...E8ProbabilityClosedRegistry,
  ...ProbabilityEventsRegistry,

  ...FormulaSubstitutionTasksRegistry,
  ...FormulaTransformTasksRegistry,
  ...SpeedDistanceTimeTasksRegistry,
  ...PolynomialBasicsTasksRegistry,

  ...ScaleTasksRegistry,
  ...SimilarityTasksRegistry,
  ...ScaleAreaVolumeTasksRegistry,
  ...UnitConversionTasksRegistry,
  ...KatyWTrojkatachTasksRegistry,
  ...AngleRelationsTasksRegistry,
  ...KatyWCzworokatachTasksRegistry,
  ...ThalesSimilarityRegistry,
  ...InteractivePointTasksRegistry,
  ...AnalyticVectorTasksRegistry,
  ...FunctionAnalysisOptimizationRegistry,

  // Działania (D1/T1/P1)
  BasicIntegerOperationsOpenTask,
  FractionCommonDenominatorOpenTask,
  FractionMixedCommonDenominatorOpenTask,
  FractionMultiplyBracketPlusMinusOpenTask,
  RootSumSquareClosedTask,
  RootSumCubeClosedTask,
  RootBinomialOpenTask,
  RationalizeSimpleDenominatorOpenTask,
  RationalizeConjugateDenominatorOpenTask,



  // Wartość bezwzględna (D1/T1/P2)
  AbsIntValueTask,
  AbsSqrtMinusIntValueTask,
  AbsSqrtAbsPairOpenTask,


  // Zbiory — suma z przecięciem (D1/T1/P3)
  InclusionExclusionModernTask,
  InclusionExclusionUnionTask,
  ListDefinedSetElementsTask,
  SetOpsFourResultsTask,
  VennSetPaintTask,

  InequalityToInfinityTask,
  InequalityBetweenTask,
  InequalityUnionOneSidedTask,
  GraphIntervalToSetTask,
  IntervalsOpsABTaskSimple: IntervalsOpsABTask,
  IntervalsOpsABTaskMixed: IntervalsOpsABTask,
  RealsMinusATask,


    // Potęgi o wykładniku naturalnym (D1/T2/P1)
  PowSumExponentsTask,
  PowDiffExponentsTask,
  PowPowerOfPowerTask,
  PowMixMulDivTask,
  PowMixParensTask,
  PowMixedFamilyToSinglePowerTask,

    // Potęgi o wykładniku całkowitym (D1/T2/P2)
  NegativeExponentBasicTask,
  PresentAsPowerWithGivenBaseTask,
  MixedFamilyIntegerToSinglePowerTask,

    // Potęgi – podtemat 3 (wymierne i pierwiastki)
  RadicalToRationalPowerTask,
  RationalPowerToRadicalTask,
  MixedFamilyRationalToSinglePowerTask,
  RadicalFractionToRationalPowerTask,
  MixedFamilyRationalFractionToSinglePowerTask,
  MixedFamilyRationalFractionBarToSinglePowerTask,

    // Potęgi – podtemat 4: Notacja wykładnicza
  ScientificFromNotationTask,
  ScientificToNotationTask,
  ScientificMultiplyTask,
  ScientificDivideTask,




  
  LogSimpleTask,
  LogDomainTask,
  LogCommonTask,

  LogPropSumTask,
  LogPropDiffTask,
  LogPropCoefTask,
  LogPropSum3Task,
  LogPropMixTask,
  LogPropCoefMixTask,
  LogPropPowerLogTask,
  LogNumberAsLogTask,

  LogComputePowerTask,

  

  // Dział 1 → Temat 4 → Podtemat 1: Obliczanie procentów
  PercentOfNumberTask,
  PercentFindWholeTask,
  PercentWhatPartTask,
  // Dział 1 → Temat 4 → Podtemat 2: Zmiany procentowe
  PercentChangeSingleTask,
  PercentChangeDoubleTask,
  PercentChangeReverseSingleTask,
  PercentChangeReverseDoubleTask,
  // Dział 1 → Temat 4 → Podtemat 3: Porównania procentowe
  PercentComparisonRelativeTask,
  PercentPointsDifferenceTask,
  PercentPartyRelativeTask,
  PercentPartyPointsTask,



  DivisibilityYesNoTask,
  DivisibilityFillDigitTask,

  PrimeFactorizationBasicTask,

  NwdNwwUnifiedTask,

  ...NaturalWrittenAdditionRegistry,
  ...NaturalWrittenSubtractionRegistry,
  ...NaturalWrittenMultiplicationRegistry,
  ...NaturalWrittenDivisionRegistry,

  
  
  SimplifyParenthesesTask,
  MultiplyBinomialsTask,
  MultiplyBinomialByTrinomialTask,
  AddOrSubtractBinomialTask,
  AddOrSubtractTrinomialTask,

  SquareOfSumTask,
  SquareOfSumLiteralTask,
  DifferenceOfSquaresTask,
  SquareOfDifferenceTask,
  SquareOfDifferenceSqrtTask,
  DifferenceOfSquaresWithRootTask,
  MixedSpecialProductsTask,
  MixedSpecialProductsSqrtTask,


  DiffSquaresOverSumOrDiffTask,
  CancelBracketFactorTask,
  MultiplyAndSimplifyRationalTask,
  DiffSquaresOverSquareExpandedTask,




  SolveSimpleLinearEquationTask,
  SolveTwoSidedLinearEquationTask,
  SolveLinearEquationWithParenthesesTask,
  SolveQuadraticsThatReduceToLinearTask,
  EquationTypeIdentificationTask,
  LinearEquationFractionsTask,

  SolveQuadraticWithoutBTask,
  SolveQuadraticWithoutCTask,
  SolveQuadraticTwoSolutionsTask,
  SolveRearrangedQuadraticTask,
  QuadraticSolutionCountTask,
  QuadraticCountAndSolveTask,
  ProductFactorsPolynomialEquationTask,
  PolynomialRootCountTask,

  RationalDomainLinearTask,
  RationalSolveAndDomainLinearTask,
  RationalSolveAndDomainLinearConstTask,
  RationalTwoFracsSolveAndDomainTask,
  RationalTwoFracsQuadraticTask,


  SolveAbsoluteLinearTask,
  SolveScaledShiftedAbsoluteLinearTask,
  CountSolutionsForAbsoluteTask,
  SolveAbsoluteEqualityTask,
  AdvancedAbsoluteEquationTask,
  LinearSystemSubstitutionEasyTask,
  LinearSystemEliminationTask,
  LinearSystemSubstitutionFractionTask,
  LinearSystemEliminationScaledTask,
  LinearSystemSubstitutionNoUnitCoeffTask,
  TwoNumbersSumDiffTask,
  TicketsSalesTask,
  NestedPercentNumbersTask,
  LinearQuadraticSubstitutionTask,
  LinearQuadraticGraphIntersectionTask,

  LinearInequalitySimpleTask,
  LinearInequalityTwoSidesTask,
  LinearInequalityFractionsTask,

  QuadraticFactoredInequalityTask,
  QuadraticGeneralInequalityTask,
  RearrangedQuadraticInequalityTask,
  QuadraticTwoSidesAllCasesTask,

  // Nierówności — wartość bezwzględna (temat3/podtemat3)
  AbsLinearInequalityTask,
  AbsLinearInequalityShiftedScaledTask,
  AbsLinearInequalityShiftedScaledAllCasesTask,
  AdvancedAbsoluteInequalityTask,


  // Funkcja — własności (dział 3 / temat 1 / podtemat 1)
  ReadFunctionFromTableTask,
  ComputeFunctionValueTask,
  PointOnGraphYesNoTask,
  LinearZeroTask,
  IsRelationFunctionTask,
  LinearArgumentForValueTask,
  LinearFunctionInequalityTask,

  LinearValueFromGraphTask,
  LinearZeroFromGraphTask,
  LinearSignFromGraphTask,
  LinearEquationFromGraphTask,
  LinearIntersectionFromGraphTask,
  LinearDerivativeTask,
  PolynomialDerivativeTask,
  ProductDerivativeTask,
  QuotientDerivativeTask,
  RationalPolynomialDerivativeTask,
  RadicalDerivativeTask,
  QuadraticMonotonicityTask,
  CubicMonotonicityTask,
  QuadraticTangentTask,
  QuadraticTangentBySlopeTask,
  PolynomialTangentTask,
  RationalTangentTask,
  QuadraticExtremumTask,
  CubicLocalExtremumTask,
  QuarticGlobalExtremumTask,

  ReadDomainFromGraphTask,
  ReadRangeFromGraphTask,
  ReadZeroFromGraphTask,
  ReadMonotonicityFromGraphTask,
  ReadFunctionValueFromGraphTask,
  ReadSignIntervalFromGraphTask,
  ReadFunctionComparisonIntervalFromGraphTask,
  ReadMaximumOnIntervalFromGraphTask,
  ReadGraphPropertiesCombinedTask,

  ShiftFunctionByVectorTask,
  ShiftVectorFromFormulaTask,
  SymmetryFunctionTask,
  SymmetryDomainRangeTask,
  AbsoluteValueSetTransformTask,
  AbsoluteValuePolylineSketchTask,
  PolylineTransformSketchTask,
  ScaleGraphSketchTask,
  ScaleSetTransformTask,

  LinearComputeValueTask,
  LinearSlopeTask,
  LinearInterceptTask,
  LinearFromTwoPointsTask,
  LinearTextDirectProportionTask,
  LinearTextTaxiFareTask,
  LinearTextFuelRemainingTask,


    // Funkcja kwadratowa — postać ogólna (dział 3 / temat 3 / podtemat 1)
  FindQuadraticCoefficientsTask,
  FindVertexFromGeneralTask,
  DeltaAndZerosCountTask,
  FindRootsFromGeneralTask,
  PlotQuadraticSpecialPointsTask,

  // Funkcja kwadratowa — postać kanoniczna (dział 3 / temat 3 / podtemat 2)
  TransformGeneralToCanonicalTask,
  TransformCanonicalToGeneralTask,
  FindAPQFromCanonicalTask,

    // Funkcja kwadratowa — postać iloczynowa (dział 3 / temat 3 / podtemat 3)
  FindAX1X2FromFactoredTask,
  TransformGeneralToFactoredTask,
  TransformFactoredToGeneralTask,

  OptimizationPairsTask,
  QuadraticExtremeArgTask,
  QuadraticExtremeValueTask,
  QuadraticExtremeOnIntervalTask,
  FenceMaxAreaAgainstWallTask,
  ProfitOptimizationStoryTask,



  FindNthTermFromLinearTask,
  FindNthTermFromQuadraticTask,
  FindNthTermFromExponentialTask,
  FindNthTermFromRationalTask,
  SumInitialTermsFromFormulaTask,

  CheckMonotonicityGivenSequenceTask,
  ComputeNextTermLinearTask,
  CheckMonotonicityFromDifferenceTask,

  CompleteRecursiveTask,
  RecursiveQuadraticTask,
  RecursiveTwoStepTask,



  FindNthTermTask,
  FindDifferenceTask,
  FindTermIndexTask,
  FindA1AndRTask,
  ArithmeticMiddleTermTask,
  ArithmeticMiddleTermEquationTask,

  FindSumTask,
  FindNFromSumTask,
  FindA1FromSumTask,
  FindRFromSumTask,

  FindLoanInstallmentsTask,
  FindCountDivisibleTask,
  Find3TermArithmeticTask,

  FindNthTermGeoTask,
  FindRatioGeoTask,
  FindTermIndexGeoTask,
  FindA1AndQGeoTask,
  FindNthTermGeoFracTask,
  GeometricConsecutiveRatioTask,
  GeometricMiddleTermTask,


  FindSumGeoTask,
  FindSumGeoNegQTask,
  FindA1FromSumGeoTask,
  FindQFromSumGeoTask,
  FindNFromSumGeoTask,


  FindFinalAmountSimpleInterestTask,
  FindFinalAmountSingleCapitalizationTask,
  FindFinalAmountMultipleCapitalizationTask,
  FindFinalAmountWithTaxTask,
  FindDailyInfectionTask,
  FindViralReachTask,
  FindXForGeometricTripletTask,

  FindSinFromTriangleTask,
  FindCosFromTriangleTask,
  FindTanFromTriangleTask,
  IdentifyTrigRatioFromTriangleTask,

  FindTriangleFromSinTask,
  FindTriangleFromCosTask,
  FindTriangleFromTanTask,

  TrigValueFromAngleTask,
  MultiplyTrigFunctionsTask,
  AddOrSubtractTrigFunctionsTask,
  ApproximateTrigValueTask,

  InclinedRoadElevationTask,
  TreeShadowTask,
  LighthouseRangeTask,

  FindSinFromPointTask,
  FindCosFromPointTask,
  FindTanFromPointTask,

  ReduceSinExactTask,
  ReduceCosExactTask,
  ReduceTanExactTask,
  ReduceSinApproxTask,
  ReduceCosApproxTask,
  ReduceTanApproxTask,

  GivenSinFindCosTanTask,
  GivenCosFindSinTanTask,
  GivenTanFindSinCosTask,
  TrigEquationIntroTask,
  AdvancedTrigEquationTask,

  FindCircumradiusFromSideAngleTask,
  FindSidesFromTwoAnglesAndOneSideTask,
  FindAnglesFromTwoSidesAndOneAngleTask,

  FindSideFromTwoSidesAndIncludedAngleTask,
  FindSideFromTwoSidesAndCosineTask,
  FindAngleFromThreeSidesTask,
  FindSideFromTwoSidesAndAdjacentAngleTask,

  ClassifyTriangleFromSidesTask,

  FindAreaFromBaseAndHeightTask,
  FindAreaFromTwoSidesAndAngleTask,
  FindAreaHeronTask,
  
  FindInradiusRightTriangleTask,
  FindInradiusEquilateralTask,
  FindInradiusFromSidesTask,
  FindCircumradiusRightTriangleTask,
  FindCircumradiusEquilateralTask,
  FindCircumradiusFromSidesTask,

  FindHypotenuseRightTriangleTask,
  ClassifyTriangleByAnglesOnlyTask,
  FindAltitudeToHypotenuseTask,

  FindHeightEquilateralTask,     // ⬅️ NOWE
  FindAreaEquilateralTask,
  FindAreaFromHeightEquilateralTask,

  
  FindCircleCircumferenceFromRadiusTask,
  FindCircleAreaFromRadiusTask,
  FindArcLengthFromAngleTask,
  FindSectorAreaFromAngleTask,
  FindAnnulusAreaFromRadiiTask,

  // VI.3 Podtemat 2
  FindInscribedFromCentralAngleTask,
  FindCentralFromInscribedAngleTask,
  FindInscribedFromTangentChordTask,
  FindTangentChordMixTask,
  FindThirdAngleInInscribedTriangleTask,

  FindAngleInSemicircleTriangleTask,
  FindBaseAngleFromRadiiTask,
  FindHiddenAngleInCircleTriangleTask,
  FindOppositeAngleInCyclicQuadrilateralTask,

  // VI.3 Podtemat 3
  FindTangentLengthTask,
  FindXFromEqualTangentsTask,
  FindPCFromSecantTangentTask,
  // VI.2 Podtemat 1 — Prostokąty i kwadraty
  RectanglePerimeterFromSidesTask,
  RectangleDiagonalFromSidesTask,
  SquareAreaFromSideTask,
  SquareDiagonalFromSideTask,
  SquarePerimeterFromSideTask,
  RectangleAreaFromSidesTask,
  // VI.2 Podtemat 2 — Równoległoboki i romby
  ParallelogramPerimeterFromSidesTask,
  ParallelogramAreaFromSideAndHeightTask,
  ParallelogramAreaFromSidesAndAngleTask,

  RhombusPerimeterFromSideTask,
  RhombusAreaFromDiagonalsTask,
    // VI.2 Podtemat 3 — Trapezy
  TrapezoidPerimeterFromSidesTask,
  TrapezoidAreaFromBasesAndHeightTask,
  TrapezoidAreaIsoscelesFromSidesTask,
  TrapezoidHeightFromAreaAndBasesTask,
  TrapezoidDiagonalRightTrapezoidTask,
  TrapezoidRightOtherLegTask,


  MidpointTask,
  FindATask,
  FindBTask,
  LengthTask,
  PerimeterTask,
  SymmetryXTask,
  SymmetryYTask,
  SymmetrySegmentTask,
  SymmetryCircleTask,
  FindSlopeTask,
  FindYInterceptTask,
  FindLineTwoPointsTask,
  SignOfLineTask,
  ConvertGeneralToSlopeTask,
  ConvertSlopeToGeneralTask,
  FindGeneralLineTwoPointsTask,
  DistancePointLineTask,
  ParallelLineThroughPointTask,
  PerpendicularLineThroughPointTask,
  FindParameterParallelTask,
  FindParameterPerpendicularTask,
  FindParameterGeneralLineRelationTask,
  FindParameterGeneralPerpendicularTask,
  IntersectionAnalysisTask,
  PerpendicularBisectorTask,
  ReadCircleFromEquationTask,
  WriteCircleEquationTask,
  WriteCircleFromCenterAndPointTask,
  WriteCircleFromDiameterTask,
  ConvertToCanonicalTask,
  ReadCenterRadiusFromGeneralTask,
  ClassifyCircleFromGeneralTask,
  CheckPointCirclePositionTask,
  LineCirclePositionTask,
  FindIntersectionPointsTask,
  FindCircleCircleIntersectionPointsTask,
  CircleCirclePositionTask,
  TriangleAreaCoordinateTask: TriangleCoordinateTasks,
  TriangleMedianEquationTask: TriangleCoordinateTasks,
  TriangleCentroidTask: TriangleCoordinateTasks,
  TriangleRightAngleCheckTask: TriangleCoordinateTasks,
  TriangleCircumcenterTask: TriangleCoordinateTasks,

  CountElementsTask,
  CountFromGivenElementTask,
  CubeDiagonalTask,
  PrismDiagonalTask,

  LateralSurfaceTask,
  ReverseLateralSurfaceTask,
  TotalSurfaceTask,
  ReverseTotalSurfaceTask,
  CuboidVolumeTask,
  RegularPrismVolumeTask,
  InverseRegularPrismDimensionTask,

  // Dział 8 → Temat 2 → Podtemat 1 (Ostrosłupy: własności i klasyfikacja)
  CountElementsFromBaseTask,
  ConvertElementsCountsTask,
  BaseAreaOfRegularPyramidTask,
  LateralEdgeFromHeight_SquareRegularPyramidTask,
  LateralEdgeFromHeight_TriangleRegularPyramidTask,
  PyramidVolumeFromBaseAreaTask,
  PyramidHeightFromVolumeTask,
  PyramidBaseAreaFromVolumeTask,
  RegularSquarePyramidVolumeTask,
  RightTriangleBasePyramidVolumeTask,

  // Dział 8 → Temat 3 → Podtemat 1 (Bryły obrotowe: walec)
  LateralSurfaceAreaOfCylinderTask, // Pb = 2πrh
  TotalSurfaceAreaOfCylinderTask,   // Pc = 2πrh + 2πr^2
  VolumeOfCylinderTask,             // V  = πr^2h
  ConeVolumeTask,
  ConeLateralSurfaceAreaTask,
  ConeTotalSurfaceAreaTask,
  ConeHeightFromVolumeTask,
  SphereSurfaceAreaTask,
  SphereVolumeTask,
  SphereRadiusFromSurfaceAreaTask,
  SphereRadiusFromVolumeTask,

  SimilarSolidVolumeFromLengthScaleTask,
  SimilarSolidVolumeFromAreaScaleTask,
  SimilarSolidAreaFromVolumeScaleTask,



  OutfitMultiplicationTask,
  AdditionOfProductsMealTask,
  DigitOnceBelowH00Task,
  DigitOnceBelowNTask,


  PermutationRaceTask,
  PermutationWithRepetitionTask,
  CinemaAdjacentPairTask,

  VariationCodeTask,
  VariationKDigitNumbersTask,
  VariationNoRepeatBooksTask,

  CombinationBouquetTask,
  CombinationTeamTask,
  CombinationTeamAtLeastOneFromEachTask,

  // 9.2.1 Podstawy
  DiceSingleRollTask,
  TwoDiceSumGreaterTask,
  UrnOneDrawTask,
  LotteryOneDrawTask,

  // 9.2.2 Zastosowania kombinatoryki
  UrnTwoDrawsTask,
  CardsTwoDrawsTask,
  CoinTossesTask,

  // 9.1.1 Statystyka opisowa — Średnie
  MeanArithmeticRawTask,
  MeanArithmeticWithUnknownTask,
  MeanGeometricRawTask,
  MeanWeightedDiaryTask,
  // 9.1.2 Statystyka opisowa — Miary położenia i zmienności
  MedianTask,
  ModeTask,
  StdDeviationTask,

  // Dział 11 — Szkoła podstawowa → Ułamki dziesiętne
  DecimalAdditionMemoryNoCarryTask,
  DecimalAdditionMemoryCarryTask,
  DecimalSubtractionMemoryNoBorrowTask,
  DecimalSubtractionMemoryBorrowTask,
  DecimalAdditionTask,
  DecimalAdditionVariableTask,
  DecimalSubtractionTask,
  DecimalSubtractionVariableTask,
  DecimalMultiplyByOneDigitTask,
  DecimalDivisionTask,
  DecimalRoundingTask,
  DecimalEstimateTask,
  // kompatybilność starszego typu
  DecimalAddSubtractTask,



};
